import { call, put, select, delay } from "redux-saga/effects";
import { setProducts, setProductsListing, setProductsBidding } from "../actions";
import { getProducts, getById } from "../../firebase/methods";
import { addProducts, updateProduct } from '../../backend/product'
import { toast } from "react-toastify";

import axios from "axios";
import Cookies from 'js-cookie'


export function* handleGetProducts(action) {
    try {
        const response = yield call(getProducts);
        let data = [];
        response.docs.forEach(doc => {
            data.push(doc.data(), doc.id);
        });
        yield put(setProducts(data));
    }
    catch (error) {
        console.log(error)
    }
}


const requestGetMyListing = (data) => {
    return axios.request({
        data,
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Cookies.get('token')
        },
        url: `${process.env.REACT_APP_SERVER_URL}/v1/dashboard-products/get-my-listings`
    })
}


const requestGetAdminListing = (data) => {

    return axios.request({
        data,
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Cookies.get('token')
        },
        url: `${process.env.REACT_APP_SERVER_URL}/v1/dashboard-products/get-all-listings`
    })
}


export function* handleGetProductsListing(action) {
    const { skip, limit, callback, searchWords, searchflag } = action.payload;
    try {
        const getUser = (state) => state.userDetails
        let getuser = yield select(getUser);
        yield delay(1000);
        const response = yield call(requestGetAdminListing, { sellerId: getuser.user._id, skip: skip, limit: limit, search: searchWords, searchflag: searchflag });


        // alert(JSON.stringify(response.data.unSkippedSize))
        yield put(setProductsListing(response.data));
        callback()
    }
    catch (error) {
        if (callback)
            callback();
        console.log(error)
    }
}

export function* handleGetUserProductsListing(action) {
    const { skip, limit, callback, searchWords, searchflag } = action.payload;
    try {
        const getUser = (state) => state.userDetails
        let getuser = yield select(getUser);
        console.log("Get User: ", getuser);
        yield delay(1000);

        const response = yield call(requestGetMyListing, { sellerId: getuser.user._id, skip: skip, limit: limit, search: searchWords, searchflag: searchflag });
        console.log("Response userProducts Listing: ", response.data);

        yield put(setProductsListing(response.data));
        callback();
    }
    catch (error) {
        if (callback)
            callback();
        console.log(error)
    }
}

const requestGetMyBidding = (data) => {
    return axios.request({
        data,
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Cookies.get('token')
        },
        url: `${process.env.REACT_APP_SERVER_URL}/v1/dashboard-products/get-my-bidding`
    })
}

export function* handleGetProductsBidding(action) {
    try {
        const callback = action.payload;
        const getUser = (state) => state.userDetails
        let getuser = yield select(getUser);
        yield delay(1000);
        const response = yield call(requestGetMyBidding, { _id: getuser.user._id });
        yield put(setProductsBidding(response.data.products));
        callback()
    }
    catch (error) {
        console.log(error)
    }
}


export function* fetchProduct({ payload: { id, callback } }) {
    try {
        //   yield put(showLoader());
        let data = yield call(getById, "products", id);
        //   yield put(hideLoader());
        if (callback) callback(data);
    } catch (error) {
        console.log("Error", error);
        if (callback) callback();
        //   yield put(hideLoader());
        toast.error("An error occurred while fetching product.");
    }
}




export function* handleAddProducts({ payload: { values, callback, history } }) {
    try {
        console.log("add product handler called. Before yielding response.", values);
        // alert(JSON.stringify(values))
        // console.log(values)
        const getUser = (state) => state.userDetails
        let getuser = yield select(getUser);
        let sellerproduct = getuser.user;
        if (sellerproduct.role[0] === "admin") {
            sellerproduct = { _id: "", firstname: "", lastname: "", role: ["admin"] }   //No seller when product added by the admin
        }
        yield delay(1000);
        const response = yield call(addProducts, { data: values, user: sellerproduct });
        // console.log(response)
        // alert(JSON.stringify(response))
        if (response.data.success) {
            if (callback) callback(response);
            toast.success("Product successfully saved!");

            if (sellerproduct.role[0] == "admin") {
                history.push("/admin-listing");
            }
            else if (sellerproduct.role[0] == "user") {
                history.push("/user-listing");
            }


        }
        else {
            if (callback) callback(response);
            toast.error(response.data.message);
        }
        console.log("Add product handler called. After Callback");
    }
    catch (error) {
        if (callback) callback();
        toast.error("An error occurred while adding the product.");
        console.log(error)
    }

}

export function* handleUpdateProduct({ payload: { data, callback, history } }) {
    try {
        console.log("Update product handler called. Before yielding response.", data);
        const getUser = (state) => state.userDetails
        let getuser = yield select(getUser);
        yield delay(1000);
        const user = getuser.user;
        data.user = user;
        const response = yield call(updateProduct, data);
        if (response.data.success) {
            if (callback) callback(response);
            toast.success("Product successfully Updated!");

            // history.push("/listing");
            if (user.role[0] == "admin") {
                history.push("/admin-listing");
            }
            else if (user.role[0] == "user") {
                history.push("/user-listing");
            }

        }
        else {
            if (callback) callback(response);
            toast.error(response.data.message);
        }
        console.log("Update product handler called. After Callback");
    }
    catch (error) {
        if (callback) callback();
        toast.error("An error occurred while editing the product.");
        console.log(error)
    }
}